export enum AccountType {
  None = 0,
  Primary = 1,
  Operations = 2,
  SecurityDeposite = 3,
  Reserve = 4,
  CAPEX = 5,
  InvestorLlc = 6,
  InvestorPersonal = 7,
  Other = 100,
}

// tslint:disable-next-line:no-namespace
export namespace AccountType {
  export function toString(orderBy: AccountType): string {
    switch (orderBy) {
      case AccountType.Primary:
        return 'Primary';
      case AccountType.Operations:
        return 'Operations';
      case AccountType.Reserve:
        return 'Reserve';
      case AccountType.CAPEX:
        return 'CAPEX';
      case AccountType.SecurityDeposite:
        return 'Security';
      case AccountType.Other:
        return 'Other';
      case AccountType.InvestorLlc:
        return 'Investor LLC';
      case AccountType.InvestorPersonal:
        return 'Investor Personal';
      default:
        return 'None'
    }
  }

  export function listAll(gpSide:boolean = true) {
    if(gpSide){
      return [
        AccountType.Primary,
        AccountType.Operations,
        AccountType.SecurityDeposite,
        AccountType.Other,
        AccountType.CAPEX,
        AccountType.Reserve
      ];
    }
    else{
      return [
        AccountType.InvestorLlc,
        // CreAccountType.InvestorPersonal
      ];
    }
  }

  export function parse(sortStr: string): AccountType {
    return AccountType[sortStr];
  }

  export function getIcon(accountType: AccountType) {
    switch (accountType) {
      case AccountType.Operations:
        return 'account-type-operational';
      case AccountType.SecurityDeposite:
        return 'account-type-security';
      case AccountType.Primary:
        return 'account-type-primary';
      case AccountType.Other:
        return 'account-type-other';
      case AccountType.Reserve:
        return 'account-type-reserve';
      case AccountType.CAPEX:
        return 'account-type-capex';
      default:
        return '';
    }
  }
}

export default AccountType;

